/**
 * Whether PostHog should send analytics events (pageviews, custom events,
 * exceptions, session recording). Feature flags remain enabled in all
 * environments where PostHog is initialized.
 */
export const isPostHogCaptureEnabled =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';
